import { IImportFileStatus } from 'ImportPackage/MainModule/interfaces/IImportFileStatus';
import { ImportFileStatusEnum } from 'APIPackage/ImportExportModule/enums/ImportFileStatusEnum';

export const importFileStatuses: IImportFileStatus[] = [
  {
    id: ImportFileStatusEnum.NEW,
    name: 'Новый',
  },
  {
    id: ImportFileStatusEnum.PROCESSING,
    name: 'В процессе обработки',
  },
  {
    id: ImportFileStatusEnum.CREATED_SUCCESS,
    name: 'Успешно создан(а)',
  },
  {
    id: ImportFileStatusEnum.CREATED_WARNINGS,
    name: 'Создан(а) с замечаниями',
  },
  {
    id: ImportFileStatusEnum.NOT_CREATED,
    name: 'Не создан(а)',
  },
  {
    id: ImportFileStatusEnum.PROCESSING_FAILED,
    name: 'Ошибка обработки файла',
  },
  {
    id: ImportFileStatusEnum.CREATED_PARTIALLY,
    name: 'Создан(а) частично',
  },
  {
    id: ImportFileStatusEnum.PROCESSING_PAUSED,
    name: 'Пауза обработки записи',
  },
];
